import { z } from "zod";

export const ScriptChatMessageRole = z.enum(["user", "model"]);
export type ScriptChatMessageRole = z.infer<typeof ScriptChatMessageRole>;

export const ScriptChatMessageDto = z.object({
  externalId: z.string(),
  createdAt: z.string(),
  role: ScriptChatMessageRole,
  content: z.string(),
});

export const ScriptChatDto = z.object({
  externalId: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
  videoExternalId: z.string(),
  messages: z.array(ScriptChatMessageDto),
});

export const CreateScriptChatResponseDto = z.object({
  chat: ScriptChatDto,
});

export const SendScriptChatMessageDto = z.object({
  message: z.string(),
});

export const GetActiveScriptChatResponseDto = z.object({
  chat: ScriptChatDto,
});

export const ScriptChatSSEUserMessageEvent = z.object({
  type: z.literal("user_message"),
  message: ScriptChatMessageDto,
});

export const ScriptChatSSEChunkEvent = z.object({
  type: z.literal("chunk"),
  chunk: z.string(),
});

export const ScriptChatSSEDoneEvent = z.object({
  type: z.literal("done"),
  message: ScriptChatMessageDto,
});

export const ScriptChatSSEErrorEvent = z.object({
  error: z.string(),
});

export const ScriptChatSSEEvent = z.discriminatedUnion("type", [
  ScriptChatSSEUserMessageEvent,
  ScriptChatSSEChunkEvent,
  ScriptChatSSEDoneEvent,
]);

export type ScriptChatSSEUserMessageEvent = z.infer<
  typeof ScriptChatSSEUserMessageEvent
>;
export type ScriptChatSSEChunkEvent = z.infer<typeof ScriptChatSSEChunkEvent>;
export type ScriptChatSSEDoneEvent = z.infer<typeof ScriptChatSSEDoneEvent>;
export type ScriptChatSSEErrorEvent = z.infer<typeof ScriptChatSSEErrorEvent>;
export type ScriptChatSSEEvent = z.infer<typeof ScriptChatSSEEvent>;
export type ScriptChatMessageDto = z.infer<typeof ScriptChatMessageDto>;
export type ScriptChatDto = z.infer<typeof ScriptChatDto>;
export type CreateScriptChatResponseDto = z.infer<
  typeof CreateScriptChatResponseDto
>;
export type SendScriptChatMessageDto = z.infer<typeof SendScriptChatMessageDto>;
export type GetActiveScriptChatResponseDto = z.infer<
  typeof GetActiveScriptChatResponseDto
>;
